import React, { useEffect, useState } from "react";

import { Header } from "../components";
import ClientTable from "../components/Clientes/Tabela";
import api from "../api/api";
import Create from "../components/Clientes/Create";
import Alerts from "../components/Alerts";
import EditClient from "../components/Clientes/Edit";
import { Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";

const Customers = () => {
  const [customersData, setCustomersData] = useState([]);
  const [userToEdit, setUserToEdit] = useState({});
  const [step, setStep] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCustomers = async () => {
      setIsLoading(true);
      try {
        const res = await api.get("/users?take=900000");
        if (res.status === 200) {
          setCustomersData(res.data.users);
        } else {
          setCustomersData([]);
        }
      } catch (error) {
        setCustomersData([]);
        setWarning({
          type: "error",
          message: "Erro ao carregar os clientes.",
        });
        handleOpenSnackbar();
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSave = () => {
    try {
      api.get("/users").then((res) => {
        if (res.status === 200) {
          setCustomersData(res.data.users);
          setStep("");
          setWarning({
            type: "success",
            message: "Lista de Clientes Atualizados!",
          });
          handleOpenSnackbar();
        } else {
          setCustomersData([]);
        }
      });
    } catch (error) {
      setWarning({
        type: "error",
        message: "Falha ao carregar os clientes!",
      });
      handleOpenSnackbar();
    }
  };

  const handleEdit = (client) => {
    setUserToEdit(client);
    setStep("edit");
  };

  const handleUpdate = async (id, data) => {
    try {
      await api.put(`users/${id}`, data);
      setWarning({
        type: "success",
        message: "Cliente Atualizado!",
      });
      handleOpenSnackbar();
      // Atualiza a lista de clientes após a edição
      const res = await api.get("/users");
      if (res.status === 200) {
        setCustomersData(res.data.users);
      }
    } catch (error) {
      setWarning({
        type: "error",
        message: "Erro ao atualizar cliente.",
      });
      handleOpenSnackbar();
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Administrativo" title="Clientes" />
      <div className="flex justify-between items-center mb-10">
        <Button
          onClick={() =>
            setStep(step === "create" || step === "edit" ? "" : "create")
          }
          variant="contained"
          color="primary"
          sx={{ mb: 5, width: "fit-content" }}
        >
          {step === "create" ? (
            <div className="flex items-center gap-2">
              <ArrowBackIcon />
              Voltar
            </div>
          ) : step === "edit" ? (
            <div className="flex items-center gap-2">
              <ArrowBackIcon />
              Voltar
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <AddIcon />
              Criar Novo Cliente
            </div>
          )}
        </Button>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center h-40">
          <CircularProgress />
        </div>
      ) : step === "create" ? (
        <Create
          onSave={handleSave}
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
        />
      ) : step === "edit" ? (
        userToEdit && (
          <EditClient
            onClose={() => setStep("")}
            client={userToEdit}
            onSave={handleUpdate}
          />
        )
      ) : (
        <ClientTable clients={customersData} onEdit={handleEdit} />
      )}
      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default Customers;
